<template>
	<section class="small-12 columns steps flex">
		<div class="small-12 stepsContainer">
			<div class="small-12 container animated fadeIn" v-if="current_step == 1">
				<div class="small-12 columns formTitle flex justify-center">
					<h2 class="small-12 large-6 text-center">
						Start by selecting the <b>type of property</b> you wish to add.
					</h2>
				</div>
				<div class="small-12 columns form">
					<fieldset class="flex small-12 propertyType">
						<label class="small-12 columns flex vertical-align justify-between">
							Residential
						</label>
						<ul class="small-12 flex" v-if="property_types">
							<li class="small-12 large-3 columns" v-for="(type, index) in property_types.residential" :key="index">
								<a class="small-12 flex justify-center propertyTypeButton border borderRadius4 active" @click="selectType(type)" v-if="new_property.type == type.value">
									<figure class="small-12" :style="propertyTypeBackgroundStyle(type.image)"></figure>
									<p class="small-12 flex text-overflow justify-center">{{type.title}}</p>
								</a>
								<a class="small-12 flex justify-center propertyTypeButton border borderRadius4" @click="selectType(type)" v-else>
									<figure class="small-12" :style="propertyTypeBackgroundStyle(type.image)"></figure>
									<p class="small-12 flex text-overflow justify-center">{{type.title}}</p>
								</a>
							</li>
						</ul>
					</fieldset>
				</div>
			</div>
			<div class="small-12 container animated fadeIn flex justify-center" v-if="current_step == 2">
				<div class="small-12 columns formTitle flex justify-center">
					<h2 class="small-12 large-6 text-center">
						Now, let's get the <b>property's address</b>.
					</h2>
				</div>
				<div class="small-12 large-6 columns form">
					<fieldset class="flex small-12 address">
						<ul class="small-12 flex">
							<li class="small-12 columns">
								<label class="small-12">Street<em class="cRed">*</em></label>
								<input type="text" name="street_1" v-model="new_property.attributes.address.street_1">
							</li>
							<li class="small-12 columns">
								<label class="small-12">Apt/Room No.</label>
								<input type="text" name="street_2" v-model="new_property.attributes.address.street_2">
							</li>
							<li class="small-12 columns">
								<label class="small-12">City<em class="cRed">*</em></label>
								<input type="text" name="city" v-model="new_property.attributes.address.city">
							</li>
							<li class="small-12 columns">
								<label class="small-12">State<em class="cRed">*</em></label>
								<div class="small-12 columns selectContainer borderRadius8" v-if="states">
									<select class="small-12 columns" name="state" v-model="new_property.attributes.address.state">
			                			<option :value="null" selected disabled>Please Choose...</option>
										<option :value="state.abbreviation" v-for="(state, stateIndex) in states.options" :key="stateIndex" :selected="new_property.attributes.address.state == state.abbreviation ? true : false">{{state.title}}</option>
			                		</select>
								</div>
							</li>
							<li class="small-12 columns">
								<label class="small-12">Zip Code<em class="cRed">*</em></label>
								<input type="text" name="zip_code" v-model="new_property.attributes.address.zip_code">
							</li>
						</ul>
					</fieldset>
				</div>
			</div>
			<div class="small-12 container animated fadeIn flex justify-center" v-if="current_step == 3">
				<div class="small-12 columns formTitle flex justify-center">
					<h2 class="small-12 large-6 text-center">
						Give it a <b>nickname</b>.
					</h2>
				</div>
				<div class="small-12 large-6 columns form">
					<fieldset class="flex small-12 nickName">
						<ul class="small-12 flex">
							<li class="small-12 columns">
								<label class="small-12">Nickname<em class="cRed">*</em></label>
								<input type="text" name="nickname" v-model="new_property.attributes.title">
							</li>
						</ul>
					</fieldset>
				</div>
			</div>
			<div class="small-12 container animated fadeIn flex justify-center" v-if="current_step == 4">
				<div class="small-12 columns formTitle flex justify-center">
					<h2 class="small-12 large-6 text-center">
						Optionally, add a <b>description</b> for future reference.
					</h2>
				</div>
				<div class="small-12 large-6 columns form">
					<fieldset class="flex small-12 nickName">
						<ul class="small-12 flex">
							<li class="small-12 columns">
								<label class="small-12">Description</label>
								<textarea class="borderRadius8" name="description" v-model="new_property.attributes.description"></textarea>
							</li>
						</ul>
					</fieldset>
				</div>
			</div>
			<div class="small-12 columns flex justify-center nextStep">
				<a class="backButton auto flex vertical-align justify-center borderRadius4 animated fadeIn" @click="previousStep()" v-if="current_step > 1">
					Previous Step
					<i class="material-icons-outlined flex justify-center vertical-align">arrow_back</i> 
				</a>
				<a class="blueButton auto flex vertical-align justify-center borderRadius4 animated fadeIn" @click="nextStep()" v-if="current_step < total_steps">
					<i class="material-icons-outlined flex justify-center vertical-align">arrow_forward</i> 
					Next Step
				</a>
				<a class="blueButton auto flex vertical-align justify-center borderRadius4 animated fadeIn" @click="getGeocodes()" v-if="current_step == total_steps">
					<i class="material-icons-outlined flex justify-center vertical-align">save</i> 
					Create Property
				</a>
			</div>
		</div>
	</section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel, propertiesModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { Autogrow } from '@/mixins/helpers/Autogrow'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
	import { GenerateUID } from '@/mixins/helpers/GenerateUID'
	import { PropertiesRepository } from '@/components/mixins/repositories/properties/PropertiesRepository'
	import { CompanyRepository } from '@/components/mixins/repositories/companies/CompanyRepository'
	import { ConfigRepository } from '@/components/mixins/repositories/config/ConfigRepository'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Steps',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			Autogrow,
			PropertiesRepository,
			ConfigRepository,
			SpinnerMethods,
			GenerateUID,
			CompanyRepository

		],

		/*
		**  Set the props
		*/

		props: {

			user: {
				type: Object,
				default: () => null
			},
			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			total_steps: 4,
			current_step: 1,
			property_types: null,
			geocodes_api_segment: 'geocodes',
			future_property_types: [
				{
					title: 'Hospitality/Golf',
					image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fproperty-type-hospitality.png?alt=media&token=46d9066d-b6ae-40a8-a5ef-d2623122237f',
					value: 'hospitality_golf'
				},
				{
					title: 'Industrial',
					image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fproperty-type-industrial.svg?alt=media&token=021e8b82-dc84-4371-9b6f-856400213762',
					value: 'industrial'
				},
				{
					title: 'Land',
					image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fproperty-type-land.svg?alt=media&token=1aad9c99-6c8f-4ecd-a7a7-e3aa5dc660e3',
					value: 'land'
				},
				{
					title: 'Manufactured Home',
					image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fproperty-type-manufactured-home.svg?alt=media&token=d94f50bc-8689-4e62-84ea-9a66e6598f64',
					value: 'manufactured_home'
				},
				{
					title: 'Campground',
					image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fproperty-type-campground.svg?alt=media&token=e25cba17-bef9-47d8-bb51-cdf455bba76d',
					value: 'campground'
				},
				{
					title: 'Mixed Use',
					image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fproperty-type-mixed-use.svg?alt=media&token=f4e885bd-0b01-4284-b453-eec14af4696c',
					value: 'mixed_use'
				},
				{
					title: 'Net Leased',
					image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fproperty-type-net-lease.svg?alt=media&token=803bcc83-9796-4c4f-b689-c7fc1b71e0f8',
					value: 'net_leased'
				},
				{
					title: 'Retail',
					image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fproperty-type-retail.svg?alt=media&token=b95ca425-115e-4014-9d77-f85cac7ed524',
					value: 'retail'
				},
				{
					title: 'Self-Storage',
					image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fproperty-type-self-storage.svg?alt=media&token=e0d1e80e-76be-4393-87d2-b726c8953a45',
					value: 'self_storage'
				},
				{
					title: 'Seniors Housing',
					image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fproperty-type-seniors-housing.svg?alt=media&token=8891f206-6034-48e0-b8e2-73de9c5042a6',
					value: 'seniors_housing'
				}
			],
			states: null

		}),

		/*
        ** Do this first
        */

        mounted() {

        	// Set autogrow
        	this.autogrowInit();

        	// Set the user
        	this.getUser;

        	// Get the config
        	this.getStates();
        	this.getPropertyTypes();
        	
        },

        /*
		**  Set up the methods
		*/

		methods: {

			propertyTypeBackgroundStyle: function(image) {

				return 'background:url(' + image + ') no-repeat center/contain;';

			},

			nextStep: function() {

				// Step 1
				if (this.current_step == 1) {

					let validated = this.validatePropertyType();

					if (!validated) {

						this.$swal('Uh Oh!', 'Please select a property type before proceeding to the next step.', 'error');

						return;

					}

				}

				// Step 2
				if (this.current_step == 2) {

					let validated = this.validateAddress();

					if (!validated) {

						this.$swal('Uh Oh!', 'Please fill out all required fields before proceeding to the next step.', 'error');

						return;

					}

				}

				// Step 3
				if (this.current_step == 3) {

					let validated = this.validateNickname();

					if (!validated) {

						this.$swal('Uh Oh!', 'Please fill out all required fields before proceeding to the next step.', 'error');

						return;

					}

				}

				// Increment the current step
				if (this.current_step < this.total_steps) this.current_step = this.current_step + 1;

				// Set autogrow
        		this.autogrowInit();

			},

			previousStep: function() {

				// Decrement the current step
				this.current_step = this.current_step - 1;

			},

			validatePropertyType: function() {

				if (this.new_property.type == null) return false;

				return true;

			},

			selectType: function(type) {

				// Set the prop
				this.new_property.type = type.value;

			},

			validateAddress: function() {

				if (this.new_property.attributes.address.street_1 == null || this.new_property.attributes.address.street_1.length == 0) return false;
				if (this.new_property.attributes.address.city == null || this.new_property.attributes.address.city.length == 0) return false;
				if (this.new_property.attributes.address.state == null || this.new_property.attributes.address.state.length == 0) return false;
				if (this.new_property.attributes.address.zip_code == null || this.new_property.attributes.address.zip_code.length == 0) return false;

				return true;

			},

			validateNickname: function() {

				if (this.new_property.attributes.title == null || this.new_property.attributes.title.length == 0) return false;

				return true;

			},

			getGeocodes: function() {

				// Show the spinner
				this.showSpinner();

				// If dev, update segment
            	if (process.env.NODE_ENV == 'development') this.geocodes_api_segment = 'geocodes-dev';

				// Send to API Gateway
				axios({
					method: 'post',
					headers: { 'content-type': 'application/json', 'x-api-key': process.env.VUE_APP_API_GATEWAY_API_KEY },
					url: process.env.VUE_APP_API_GATEWAY_BASE_URL + '/google/' + this.geocodes_api_segment,
					data: {
						address: {
							street_1: this.new_property.attributes.address.street_1,
							city: this.new_property.attributes.address.city,
							state: this.new_property.attributes.address.state
						}
					}
				})
				.then(response => {

					// Add to the new property object
					this.new_property.relationships.places = response.data.results[0];

				})
				.then(() => {

					// Check if property exists
					this.propertyExistsCheck();

				})
				.catch(error => {

					// Hide the spinner
					this.hideSpinner();

					// Redirect to the properties dashboard page
					this.$router.push({ name: 'PropertiesDashboard' }); 

					// Send user message
					this.$swal('Uh Oh!', 'The property address you have entered cannot be found.', 'error');

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Create Property - Get Geocodes From Lambda Function',
						errorType: 'AWS Lambda',
						section: 'Create Property',
						component: 'Steps',
						error: error
					});

				});
				

			},

			propertyExistsCheck: function() {

				propertiesModel.where('relationships.places.place_id', '==', this.new_property.relationships.places.place_id).where('meta.deleted_at', '==', null).get()
				.then(snapshot => {

					if (snapshot.empty) {

						// Create the property
						this.createProperty();

					} else {

						// Hide the spinner
						this.hideSpinner();

						// Inform user
						this.$swal('Uh Oh!', 'Looks like this property has already been claimed.', 'error');

					}

				})
				.catch(error => {

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Create Property - Check if Property Exists',
						errorType: 'AWS Lambda',
						section: 'Create Property',
						component: 'Steps',
						error: error
					});

				});

			}

		},

		 /*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>